import React from 'react';
import { ShieldAlert, Lock, Home, ArrowRight } from 'lucide-react';

const UnauthorizedView = ({ error, countdown, loading }) => {
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6 text-center">
        <div className="relative">
          <div className="w-20 h-20 border-4 border-teal-100 border-t-teal-600 rounded-full animate-spin"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <Lock className="h-8 w-8 text-teal-600" />
          </div>
        </div>
        <h2 className="mt-8 text-2xl font-bold text-slate-800">Verifying Permissions</h2>
        <p className="mt-2 text-slate-500">Secure Healthcare Portal is checking your access rights...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-[2.5rem] shadow-2xl border border-slate-100 overflow-hidden">
          {/* Header/Banner */}
          <div className="bg-gradient-to-r from-red-600 to-rose-500 p-12 flex flex-col items-center text-center">
            <div className="h-24 w-24 rounded-3xl bg-white/20 backdrop-blur-md flex items-center justify-center mb-6 shadow-xl">
              <ShieldAlert className="h-12 w-12 text-white" />
            </div>
            <h1 className="text-4xl font-black text-white tracking-tight uppercase">Access Denied</h1>
            <div className="mt-4 h-1 w-20 bg-white/30 rounded-full" />
          </div>

          {/* Content */}
          <div className="p-12 text-center">
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-slate-800">
                Unauthorized Territory
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed max-w-md mx-auto">
                You do not have the required permissions to access this administrative module. 
                Please contact your <span className="text-red-600 font-semibold text-bold">System Administrator</span> if you believe this is an error.
              </p>

              {error && (
                <div className="bg-red-50 border border-red-100 rounded-2xl p-4 flex items-center justify-center space-x-3">
                  <span className="text-red-600 text-sm font-medium">System Message: {error}</span>
                </div>
              )}

              <div className="pt-8 border-t border-slate-100">
                <div className="flex flex-col items-center space-y-6">
                  <div className="flex items-center space-x-2 text-slate-400 font-medium">
                    <span>Redirecting to Login Phase in</span>
                    <span className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-800 font-bold">
                      {countdown}
                    </span>
                    <span>seconds</span>
                  </div>

                  <a
                    href="/"
                    className="group flex items-center space-x-3 bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-2xl font-bold transition-all duration-300 shadow-xl hover:shadow-teal-600/20 active:scale-95"
                  >
                    <Home className="h-5 w-5" />
                    <span>Return to Home</span>
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-slate-50 py-6 text-center border-t border-slate-100">
            <p className="text-slate-400 text-sm font-medium uppercase tracking-widest">
              Surgix &bull; Healthcare Excellence
            </p>
          </div>
        </div>
      </div>
      
      {/* Background Decorative Elements */}
      <div className="fixed inset-0 pointer-events-none z-[-1] opacity-50">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-100 rounded-full blur-[100px] animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-teal-50 rounded-full blur-[120px] animate-pulse delay-1000" />
      </div>
    </div>
  );
};

export default UnauthorizedView;
